<style scoped>
	@import '../../assets/css/login.css';
</style>

<template>
	
	<div class="login-container" >
		<div class="background"></div>
		<div style="flex: 1;">
			<div align="center">
				<div class="login-box">
					<form id="loginForm" @submit.prevent="submit">
						<div class="login-wrap mt-3">
							<img src="../../assets/img/app/logo.png" class="login-logo"/>
						</div>
						
						<div class="login-wrap mt-3">
							<input class="login-input-1" type="text" name="username" :placeholder="$t('login.table_username')" v-model="username" @keyup.enter="submit()"/>
							<span class="login-symbol">
								<font-awesome-icon icon="user" size="lg"></font-awesome-icon>
							</span>
						</div>

						<div class="login-wrap">
							<input class="login-input-2" type="password" name="password" :placeholder="$t('login.table_password')" v-model="password" @keyup.enter="submit()"/>
							<span class="login-symbol">
								<font-awesome-icon icon="key" size="lg"></font-awesome-icon>
							</span>
						</div>
						
						<div class="login-wrap">
							<button type="button" class="login-button mt-3" @click="submit()">{{$t('button.login')}}</button>
						</div>
					</form>
					
					<b-row class="login-language-hr">
						<b-col><hr class="login-hr" /></b-col>
						<b-col><p class="login-language">{{$t('general.language')}}</p></b-col>
						<b-col><hr class="login-hr" /></b-col>
					</b-row>
					
					<b-row class="login-language mb-3">
						<b-col v-if="languageList != ''" v-for="thisLanguage in languageList" @click="switch_language(thisLanguage.code)">
							<p class="language-border" v-if="thisLanguage.code == 'en'">EN</p>
							<p class="language-border" v-if="thisLanguage.code == 'cn'">中</p>
							<p class="language-border" v-if="thisLanguage.code == 'jp'">日</p>
							<p class="language-border" v-if="thisLanguage.code == 'zh_cn'">繁</p>
							<p class="mt-1">{{thisLanguage.name}}</p>
						</b-col>
					</b-row>
				</div>
			</div>
			
			<div class="login-footer">
				<span>{{$t('general.powered')}}</span>
			</div>
		</div>
	</div>
	
</template>

<script>
import {getLogin, login} from '@/system/model/login';
import {getTokenByName} from '@/system/store/cookie';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';

export default {
	inject:['preloader'],
	data(){
		return{
			currentLang: '',
			languageList: '',
			csrfName: '',
			csrfValue: '',
			csrfNameKey: '',
			csrfValueKey: '',
			username: '',
			password: '',
			errors: [],
			validate: true,
			ajaxLoad: false,
			submitButton: true,
		}
	},methods:{
		initialize(){
			var result = getLogin();
			var self = this;
			result.then(function(value){
				if(value.valid){
					self.ajaxLoad = true;
					setLocalStorage('language_list', JSON.stringify(value.data.language_list));
					self.languageList = value.data.language_list;
					self.csrfName = value.data.csrf_list.csrf_name;
					self.csrfValue = value.data.csrf_list.csrf_value;
					self.csrfNameKey = value.data.csrf_list.csrf_name_key;
					self.csrfValueKey = value.data.csrf_list.csrf_value_key;
				}
				self.preloader(false);
			});
		},switch_language(selectLang){
			setLocalStorage('currentLang', selectLang);
			this.$i18n.locale = selectLang;
			this.currentLang = selectLang;
		},submit(){
			if(this.submitButton){
				var self = this;
				var text = "";
				this.errors = [];
				
				if(!this.username){
					this.validate = false;
					this.errors.push('login.error_username_empty');
				}
				
				if(!this.password){
					this.validate = false;
					this.errors.push('login.error_password_empty');
				}
				
				if(this.validate){
						this.submitButton = false;
						this.preloader(true);
						
						var form = document.getElementById('loginForm');
						var formData = new FormData(form);
						formData.append(this.csrfNameKey, this.csrfName); 
						formData.append(this.csrfValueKey, this.csrfValue); 
						var result = login(formData);
						
						result.then(function(value){
							if(value.valid){
								self.submitButton = true;
								setLocalStorage('permission_list', JSON.stringify(value.permission));
								setLocalStorage('username', value.login);
								self.$router.push('/home');
							}else{
								self.preloader(false);
								
								if(Array.isArray(value.returnMsg)){
									self.errors = value.returnMsg;
								}else{
									self.errors.push(value.returnMsg);
								}
								
								
								self.errors.forEach(function (value) {
									text += self.$t(value)+"<br />";
								}); 
								
								self.$swal.fire({
									type: 'error',
									html: text,
									onClose: () => {
										location.reload();
									}
								});
									
								self.validate = false;
							}
						});
				}else{
					self.errors.forEach(function (value) {
						text += self.$t(value)+"<br />";
					}); 
					
					this.$swal.fire({
						type: 'error',
						html: text,
					});
								
					this.validate = true;
					this.submitButton = true;
				}
			}
		}
	},created(){
		if(getTokenByName('auth_sign_token')){
			this.$router.push('/home');
		}else{
			this.preloader(false);
			this.initialize();			
		}
	}
}
</script>
